/* TODO consume from core-js after
     BCP-1698-Core-js-add-redux-toolkit-main-branch will be merged */
export function setState(state, newState) {
  Object.assign(state, newState);
}
